import React, { ReactNode } from 'react';
import GlobalModal from './modal';
import { ButtonComponent, ButtonStyling } from '../form/elements/button';
import css from './modal.module.css';

export interface OptionDialogButton {
  title: string;
  name: string;
  value: any;
  ignoreValidation?: boolean;
}

export default function OptionModal({
  title,
  content,
  buttons,
  onChoice,
  onClose,
  className,
  shouldCloseOnOverlayClick = true,
  buttonStyle,
}: {
  title?: string;
  content?: string | ReactNode;
  buttons: OptionDialogButton[];
  onChoice: (value: any) => void;
  onClose: () => void;
  className?: string;
  shouldCloseOnOverlayClick?: boolean;
  buttonStyle?: ButtonStyling;
}) {
  const body = (
    <>
      {title && <h1 className={css['title']}>{title}</h1>}
      {content && <div className={css['message']}>{content}</div>}
    </>
  );

  const getStyling = (index: number) => {
    if (buttonStyle) {
      return buttonStyle;
    }

    return index === 0 ? ButtonStyling.primary : ButtonStyling.cancel;
  };

  return (
    <GlobalModal
      visible={true}
      body={body}
      onClose={onClose}
      className={className}
      customOverlayClassName={className}
      buttons={buttons.map((button, index) => (
        <ButtonComponent
          key={button.title}
          name={button.name}
          styling={getStyling(index)}
          label={button.title}
          click={() => onChoice(button.value)}
          {...(button.ignoreValidation && {
            ignoreValidation: button.ignoreValidation,
          })}
        />
      ))}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    />
  );
}
